import { RULESET as u, KEYFRAMES as i, COMMENT as c, DECLARATION as l, IMPORT as o, LAYER as f } from "./index.es255.js";
import { strlen as a } from "./index.es345.js";
function e(r, n) {
  for (var t = "", s = 0; s < r.length; s++)
    t += n(r[s], s, r, n) || "";
  return t;
}
function m(r, n, t, s) {
  switch (r.type) {
    case f:
      if (r.children.length) break;
    case o:
    case l:
      return r.return = r.return || r.value;
    case c:
      return "";
    case i:
      return r.return = r.value + "{" + e(r.children, s) + "}";
    case u:
      if (!a(r.value = r.props.join(","))) return "";
  }
  return a(t = e(r.children, s)) ? r.return = r.value + "{" + t + "}" : "";
}
export {
  e as serialize,
  m as stringify
};
//# sourceMappingURL=index.es257.js.map
